export default {"src":"/_next/static/media/earth-globe.dbbcbb70.svg","height":532,"width":533,"blurWidth":0,"blurHeight":0};